import request from '@/utils/request'

export function getDeptList(data) {
  return request.post('/dept/list', data)
}



// WEBPACK FOOTER //
// ./src/api/dept.js